export default __webpack_public_path__ + "static/media/trolley.13c1b86d.gif";